module.exports = __webpack_public_path__ + "img/undermonterad.acf487d9.png";